/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Stats_Page_TitleInputs */

const vi_warehouse_stats_page_title = /** @type {(inputs: Warehouse_Stats_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê kho`)
};

/**

* @param {Warehouse_Stats_Page_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_stats_page_title = /** @type {((inputs?: Warehouse_Stats_Page_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Stats_Page_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_stats_page_title(inputs)
});